import { SvgIconType } from './svg.interface';

const Card: SvgIconType = ({
  width = 12,
  height = 12,
  className = '',
  color = '#3AA5DC'
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 3H0V2.4375C0 1.91973 0.335786 1.5 0.75 1.5H11.25C11.6642 1.5 12 1.91973 12 2.4375V3ZM12 4.875V9.75C12 10.1642 11.6642 10.5 11.25 10.5H0.75C0.335786 10.5 0 10.1642 0 9.75V4.875H12ZM3 7.5C2.58579 7.5 2.25 7.83579 2.25 8.25C2.25 8.66421 2.58579 9 3 9H3.75C4.16421 9 4.5 8.66421 4.5 8.25C4.5 7.83579 4.16421 7.5 3.75 7.5H3Z"
      fill={color}
    />
  </svg>
);

export default Card;
